export default {
    title: "Central de beneficios",
    loadError: "No se pudo cargar la central de beneficios.",
    saveError: "No se pudo guardar la central de beneficios.",
    saveSuccess: "Configuración guardada con éxito.",
    preview: {
        title: "Vista previa",
        placeholder: "Espacio reservado para la vista previa",
        screenLogin: "Login",
        screenApp: "App",
        link: "Enlace de acceso",
        linkCopied: "Enlace copiado",
        open: "Ver vista previa",
        close: "Cerrar vista previa",
    },
    tabs: {
        label: "Secciones de la central de beneficios",
        settings: "Configuración",
        tiers: "Niveles",
        points: "Programa de puntos",
        referrals: "Indicación",
        cashback: "Cashback",
        empty: "Esta sección se configurará en los próximos pasos.",
        comingSoon: "Próximamente",
    },
    settings: {
        clubName: "Nombre del club",
        clubNameRequired: "El nombre del club es obligatorio.",
        logo: "Logo",
        logoUploadTitle: "Elige una imagen o arrástrala aquí.",
        logoUploadDescription: "Usa una imagen en .jpg o .png",
        logoUploadButton: "Buscar imagen",
        logoUploadDelete: "Eliminar logo",
        font: "Fuente",
        color: "Color",
        defaultFont: "Predeterminado",
        advanced: "Configuración avanzada",
        showStatement: "Mostrar extracto",
        customCss: "CSS personalizado",
    },
    tiers: {
        systemLabel: "Sistema de niveles",
        title: "Niveles",
        emptyTitle: "Crea tu sistema de niveles",
        emptyDescription: "Configura niveles para reconocer clientes según su interacción y frecuencia de compra.",
        createFirst: "Crear primer nivel",
        addLevel: "Añadir nivel",
        panel: {
            close: "Cerrar",
            sectionsLabel: "Panel de configuración de nivel",
            name: "Nombre del nivel",
            namePlaceholder: "Ej: VIP, Oro, Embajador...",
            description: "Descripción",
            descriptionPlaceholder: "Breve explicación sobre quién pertenece a este nivel",
            segment: "Segmento",
            segmentPlaceholder: "Selecciona el segmento",
            becoming: "¿Cómo alcanzarlo?",
            becomingPlaceholder: "Ej: Acumula 10,000 puntos en 12 meses",
            sharedRewards: "Recompensas compartidas",
            sharedRewardsEmpty: "Ninguna recompensa configurada",
            tierRewards: "Recompensas exclusivas del nivel",
            tierRewardsPlaceholder: "Añadir recompensa exclusiva",
            tierColor: "Color del nivel",
            textColor: "Color del texto",
            iconType: "Tipo de icono",
            emoji: "Emoji",
            emojiPlaceholder: "Pega un emoji aquí (ej: 👑)",
            svg: "Icono personalizado (SVG)",
            svgPlaceholder: "Pega el código <svg> aquí",
            preview: "Vista previa de la tarjeta",
            cancel: "Cancelar",
            save: "Guardar nivel",
            settings: "Configuración",
            design: "Diseño",
            iconEmoji: "Emoji",
            iconSvg: "SVG",
            previewName: "Nombre del nivel",
            previewDescription: "Descripción del nivel",
        },
        examples: {
            bronze: {
                title: "Bronce",
                description: "Forman parte de nuestro grupo de compradores activos.",
            },
            silver: {
                title: "Plata",
                description: "Los clientes Plata demuestran frecuencia de compra y mayor interacción con nuestro ecosistema.",
            },
            gold: {
                title: "Oro",
                description: "Los clientes Oro son altamente activos y están entre quienes más aprovechan nuestro programa.",
            },
        },
    },
    points: {
        systemLabel: "Programa de puntos",
        pointsFactorLabel: "¿Cuánto debe gastar el cliente ({currency}) para ganar 1 punto?",
        maxPointsPerOrderLabel: "¿Cuál es el límite de puntos por pedido?",
        maxPointsPerOrderPlaceholder: "Sin límite",
        accrualPreview: "{amount} → {points} puntos",
        accrualPreviewCapped: "{amount} → {points} puntos (límite por pedido)",
        title: "Recompensas",
        addReward: "Añadir recompensa",
        pointsLabel: "puntos",
        deleteModalTitle: "¿Estás seguro?",
        deleteModalDescription: "Esta recompensa será eliminada permanentemente.",
        deleteModalCancel: "Cancelar",
        deleteModalConfirm: "Eliminar",
        deactivateModalTitle: "¿Desactivar programa de puntos?",
        deactivateModalDescription: "Al desactivar el programa de puntos, las siguientes automatizaciones activas se pausarán automáticamente:",
        deactivateModalEmptyDescription: "¿Está seguro de que desea desactivar el programa de puntos?",
        deactivateModalImpactTitle: "Además:",
        deactivateModalImpactSales: "Las nuevas ventas ya no acumularán puntos para los clientes.",
        deactivateModalImpactSegments: "Los segmentos que usan filtros de saldo de puntos dejarán de actualizarse.",
        deactivateModalImpactRewards: "Los clientes no podrán canjear recompensas de puntos.",
        deactivateModalConfirm: "Desactivar programa",
        emptyTitle: "Crea tus recompensas",
        emptyDescription: "Crea recompensas del programa de puntos para ofrecer a tus clientes.",
        createFirst: "Crear primera recompensa",
        panel: {
            createTitle: "Añadir recompensa",
            editTitle: "Editar recompensa",
            close: "Cerrar",
            sectionsLabel: "Secciones de la recompensa",
            details: "Detalles",
            rules: "Reglas",
            name: "Nombre de la recompensa",
            namePlaceholder: "Ej: Vaso térmico exclusivo",
            subtitle: "Subtítulo",
            subtitlePlaceholder: "Ej: Canjea por 500 puntos",
            description: "Descripción",
            descriptionPlaceholder: "Describe los detalles de la recompensa...",
            image: "Imagen",
            imagePlaceholder: "Selecciona una imagen para esta recompensa",
            points: "Puntos",
            pointsPlaceholder: "Ej: 500",
            privacy: "Privacidad",
            privacyAll: "Mostrar para todos",
            privacyBlurred: "Mostrar ofuscada para todos",
            privacySpecific: "Clientes en segmentos específicos",
            startDate: "Fecha de inicio",
            endDate: "Fecha de fin",
            clearDate: "Limpiar",
            canUse: "Permitir canje manual por el sistema",
            clientCanUse: "El cliente puede usar la recompensa",
            clientCanUseHintOn: "El cliente canjea la recompensa en la app y los puntos se descuentan automáticamente.",
            clientCanUseHintOff: "El cliente solo puede ver la recompensa; el canje debe ser realizado por el equipo en el sistema.",
            howToUse: "Cómo usar la recompensa",
            howToUseInstructions: "¿Cómo usar esta recompensa?",
            howToUseInstructionsPlaceholder: "Describa las instrucciones de uso...",
            successMessage: "Mensaje de éxito",
            successMessagePlaceholder: "Escribe lo que el cliente verá justo después de canjear la recompensa en la app, como una confirmación o una indicación del próximo paso.",
            usageOption: "Cómo el cliente usa la recompensa",
            usageOptionRequired: "Marca al menos una de las opciones anteriores: sin ninguna, el cliente no puede usar la recompensa ni sabe cómo usarla.",
            hasUsageInstructions: "Añadir instrucciones de uso",
            usageInstructions: "Instrucciones de uso",
            usageInstructionsPlaceholder: "Ej: Presenta el código en la caja...",
            cancel: "Cerrar",
            save: "Guardar",
            saveChanges: "Guardar cambios",
            delete: "Eliminar",
            deleteBlocked: "No se puede eliminar una recompensa que ya fue canjeada.",
            confirmDelete: "¿Seguro que quieres eliminar esta recompensa?",
            deleteSuccess: "¡Recompensa eliminada con éxito!",
            createSuccess: "¡Recompensa creada con éxito!",
            editSuccess: "¡Recompensa guardada con éxito!",
            createError: "Error al crear la recompensa.",
            editError: "Error al actualizar la recompensa.",
            createRewardButton: "Crear recompensa",
            imageUploadTitle: "Elige un archivo o arrástralo aquí.",
            imageUploadDesc: "Usa la resolución 1920x1080. Solo .jpg .png",
            imageUploadButton: "Buscar archivo",
            imageUploadDelete: "Eliminar imagen",
            missingFieldsTooltip: "Complete los campos obligatorios: {fields}"
        },
        exampleCost: "7 puntos",
        exampleName: "Borde especial",
        exampleSubtitle: "Cupón de R$13,90"
    },
    login: {
        title: "Pantalla de login",
        background: "Background",
        solidColor: "Color sólido",
        image: "Imagen",
        color: "Color",
        backgroundImageTitle: "Elige una imagen o arrástrala aquí.",
        backgroundImageDescription: "Usa una imagen en .jpg o .png",
        backgroundImageButton: "Buscar imagen",
        deleteBackgroundImage: "Eliminar imagen de background",
        form: "Formulario",
        firstName: "Nombre",
        lastName: "Apellido",
        birthDate: "Fecha de nacimiento",
        email: "Email",
        required: "Obligatorio",
    },
    faq: {
        title: "Preguntas frecuentes",
        addQuestion: "Agregar pregunta",
        addQuestionTitle: "Agregar pregunta",
        editQuestion: "Editar pregunta",
        editQuestionTitle: "Editar pregunta",
        deleteQuestion: "Eliminar pregunta",
        question: "Pregunta",
        answer: "Respuesta",
        questionPlaceholder: "¿Cómo canjeo mis puntos?",
        answerPlaceholder: "Ingresa la respuesta",
        introTitle: "Título de la sección",
        introTitlePlaceholder: "Preguntas frecuentes",
        introShowTitle: "Mostrar el título",
        introImage: "Imagen",
        introShowImage: "Mostrar la imagen",
        introImageTitle: "Elige una imagen o arrástrala aquí.",
        introImageDescription: "Usa una imagen en .jpg o .png",
        introImageButton: "Buscar imagen",
        introImageDelete: "Eliminar imagen del FAQ",
        introText: "Texto de introducción",
        introTextPlaceholder: "Escribe un texto que aparece antes de las preguntas",
        introShowText: "Mostrar el texto de introducción",
        close: "Cerrar",
        saveChanges: "Guardar cambios",
        deleteModalTitle: "Eliminar pregunta",
        deleteModalDescription: "¿Seguro que quieres eliminar esta pregunta?",
        deleteModalCancel: "Cancelar",
        deleteModalConfirm: "Eliminar",
        emptyError: "Llena la pregunta antes de guardar.",
        saveError: "Ocurrió un error al guardar la pregunta.",
        addSuccess: "¡Pregunta agregada con éxito!",
        updateSuccess: "¡Pregunta actualizada con éxito!",
        deleteSuccess: "¡Pregunta eliminada con éxito!",
        deleteError: "Ocurrió un error al eliminar la pregunta.",
    },
    terms: {
        title: "Términos y condiciones",
        settings: "Configurar",
        panelTitle: "Términos y condiciones",
        bodyPlaceholder: "Ingresa los términos y condiciones",
        close: "Cerrar",
        saveChanges: "Guardar cambios",
        success: "¡Términos actualizados con éxito!",
        error: "Ocurrió un error al guardar los términos.",
    },
    banners: {
        title: "Banners",
        count: "Cantidad {0}/{1}",
        dropTitle: "Elige un archivo o arrástralo aquí.",
        dropDescription: "Usa la resolución 1920x1080. Solo .jpg .png",
        limitReachedTitle: "Límite de banners alcanzado",
        limitReachedDescription: "Ya agregaste 5 banners. Elimina un banner para agregar otro.",
        searchFile: "Buscar archivo",
        dragHandle: "Reordenar banner",
        addLinkAction: "Agregar enlace",
        editLinkAction: "Editar enlace",
        deleteAction: "Eliminar banner",
        linkModalTitle: "Configurar enlace de redireccionamiento",
        linkLabel: "Enlace",
        copyLink: "Copiar enlace",
        copyLinkAgain: "Copiar de nuevo",
        linkCopied: "Copiado",
        linkModalSave: "Guardar",
        deleteModalTitle: "Eliminar banner",
        deleteModalDescription: "¿Seguro que quieres eliminar este banner?",
        deleteModalCancel: "Cancelar",
        deleteModalConfirm: "Eliminar",
        statusCompleted: "Completado",
        statusUploading: "Enviando..",
        statusError: "Error al enviar",
    },
    colorPicker: {
        title: "Selecciona un color",
        basics: "Básicas",
        hex: "Hex",
        open: "Abrir selector de color",
        saturationBrightness: "Saturación y brillo",
        saturationBrightnessValue: "Saturación {0}%, brillo {1}%",
        hue: "Matiz",
    },
    upload: {
        oversized: "El tamaño máximo por imagen es {0}MB. Las siguientes imágenes excedieron el límite: {1}",
        parseError: "Error al interpretar la respuesta del servidor.",
        serverError: "Ocurrió un error en el servidor al intentar enviar las imágenes.",
        httpError: "Error {0} al realizar el upload.",
        networkError: "Error de red. Verifique su conexión a Internet.",
        success: "¡Upload realizado con éxito!",
        deleted: "¡Imagen eliminada con éxito!",
        bannerDeleted: "¡Banner eliminado con éxito!",
        deleteModalTitle: "Eliminar imagen",
        deleteModalDescription: "¿Seguro que quieres eliminar esta imagen?",
        uploadError: "Error al cargar la imagen.",
    },
};
